module.exports = __webpack_public_path__ + "img/02.55ff690c.jpg";